import styled from 'styled-components';
import { Alert } from '@landlord-tech/ui-kit-opp/dist/components/Alert';

const SAlert = styled(Alert)`
  &&& {
  }
`;

export default SAlert;
